import ApiService from "../api";

/** Converte o objeto de filtros em query string, ignorando valores vazios. */
function paraQuery(filtros = {}) {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([chave, valor]) => {
        if (valor === null || valor === undefined || valor === "") return;
        if (Array.isArray(valor)) {
            valor.forEach(v => params.append(chave, v));
        } else {
            params.append(chave, valor);
        }
    });
    return params.toString();
}

export default class TiInventarioService extends ApiService {

    constructor() {
        super("/api/ti");
    }

    // ---- metadados e relatório
    metadados() {
        return this.get("/ativos/metadados");
    }

    listarAtivos(filtros) {
        return this.get(`/ativos?${paraQuery(filtros)}`);
    }

    resumo(filtros) {
        return this.get(`/ativos/resumo?${paraQuery(filtros)}`);
    }

    exportar(filtros, formato, colunas) {
        return this.getFile(`/ativos/exportar?${paraQuery({ ...filtros, formato, colunas })}`);
    }

    /** Sugestões de nome/cargo (usuários do sistema e funcionários do Fortes) — apenas apoio ao texto livre. */
    sugerirResponsaveis(q, origem = "TODOS") {
        return this.get(`/responsaveis/sugestoes?${paraQuery({ q, origem })}`);
    }

    buscarParaVinculo(q, excluirId) {
        return this.get(`/ativos/busca-vinculo?${paraQuery({ q, excluirId })}`);
    }

    // ---- ativo
    buscarAtivo(id) {
        return this.get(`/ativos/${id}`);
    }

    criarAtivo(dto) {
        return this.post("/ativos", dto);
    }

    atualizarAtivo(id, dto) {
        return this.put(`/ativos/${id}`, dto);
    }

    movimentar(id, dto) {
        return this.post(`/ativos/${id}/movimentar`, dto);
    }

    movimentacoes(id) {
        return this.get(`/ativos/${id}/movimentacoes`);
    }

    // ---- anexos
    listarAnexos(id) {
        return this.get(`/ativos/${id}/anexos`);
    }

    anexar(id, arquivo, tipoDocumento, descricao) {
        const form = new FormData();
        form.append("arquivo", arquivo);
        if (tipoDocumento) form.append("tipoDocumento", tipoDocumento);
        if (descricao) form.append("descricao", descricao);
        return this.post(`/ativos/${id}/anexos`, form, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }

    baixarAnexo(anexoId) {
        return this.getFile(`/ativos/anexos/${anexoId}/download`);
    }

    excluirAnexo(anexoId) {
        return this.delete(`/ativos/anexos/${anexoId}`);
    }

    // ---- termos de responsabilidade
    listarTermos(id) {
        return this.get(`/ativos/${id}/termos`);
    }

    /** Registra quem recebeu o equipamento; `arquivo` (documento assinado) é opcional. */
    registrarTermo(id, { recebedorNome, recebedorCargo, dataRecebimento, observacao }, arquivo) {
        const form = new FormData();
        form.append("recebedorNome", recebedorNome);
        if (recebedorCargo) form.append("recebedorCargo", recebedorCargo);
        form.append("dataRecebimento", dataRecebimento);
        if (observacao) form.append("observacao", observacao);
        if (arquivo) form.append("arquivo", arquivo);
        return this.post(`/ativos/${id}/termos`, form, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }

    anexarDocumentoDoTermo(termoId, arquivo) {
        const form = new FormData();
        form.append("arquivo", arquivo);
        return this.post(`/ativos/termos/${termoId}/documento`, form, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }

    // ---- cadastros auxiliares
    listarCatalogo(tipo, { somenteAtivos = false, comUso = false } = {}) {
        return this.get(`/catalogos?${paraQuery({ tipo, somenteAtivos, comUso })}`);
    }

    cadastrarCatalogo(dto) {
        return this.post("/catalogos", dto);
    }

    atualizarCatalogo(id, dto) {
        return this.put(`/catalogos/${id}`, dto);
    }

    alterarAtivoCatalogo(id, valor) {
        return this.patch(`/catalogos/${id}/ativo?valor=${valor}`);
    }

    excluirCatalogo(id) {
        return this.delete(`/catalogos/${id}`);
    }
}

/** Salva uma resposta binária (blob) do axios como arquivo no navegador. */
export function salvarBlob(resposta, nomeArquivo) {
    const url = URL.createObjectURL(resposta.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = nomeArquivo;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
